import useStyles from './PDFBackgroundImage.styled'

export const usePDFBackgroundImage = props => {
	const { image, onClick } = props
	const classes = useStyles(props)

	return [
		{
			image,
			classes,
		},
		{
			handleClick: onClick,
		},
	]
}
